import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const stocksJourneyRoutes = [
  {
    id: 'stocks-sell',
    trackingName: 'Stocks Sell',
    path: 'web/view/stocks/sell/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyStocksSell')).JourneyStocksSell,
    }),
  },
  {
    id: 'stocks-buy',
    trackingName: 'Stocks Buy',
    path: 'web/view/investing/buy/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyInvestingBuy')).JourneyInvestingBuy,
    }),
  },
  {
    id: 'stocks-activity',
    trackingName: 'Stocks View All Activity',
    path: 'web/view/investing/activity/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyInvestingActivity')).JourneyInvestingActivity,
    }),
  },
] as const satisfies JourneyRoute[]
